/*! Wave Colour Studio, (c) afzuigkapSpecialist.nl. Alle rechten voorbehouden. Kopieren, hergebruiken of doorverkopen zonder schriftelijke toestemming is niet toegestaan. */
/* Mail mijn ontwerp (okt 2026):
   - altijd: contactformulier naar de winkel (backup, zoals voorheen);
   - met toestemming-vinkje: daarnaast klantformulier -> klant met tags "ontwerp-mail" + notitie met het ontwerp.
     Shopify Flow (trigger 'Klant aangemaakt', tag ontwerp-mail) zet het ontwerp in metavelden en verstuurt de mail via Shopify Email.
   Bestaande klanten werkt het klantformulier niet bij (Shopify-beperking); dan mailt de winkel handmatig o.b.v. het contactbericht. */
(function () {
  var WVS = window.WVS, api = null;

  function init() {
    if (api || !WVS.api) return;
    api = WVS.api;
    var prev = api.prev, root = api.root, cv = api.cv, state = api.state,
      nCustom = api.nCustom, tintFor = api.tintFor, handle = api.handle,
      m1 = api.m1, m2 = api.m2, in1 = api.in1, in2 = api.in2, soon = api.soon;

    var box = document.createElement('div');
    box.className = 'wvs-act';
    box.innerHTML =
      '<div class="wvs-btnrow">' +
        '<button type="button" class="wvs-btn" data-a="dl">Download als afbeelding</button>' +
        '<button type="button" class="wvs-btn wvs-btn--pri" data-a="mail" aria-expanded="false">Mail mijn ontwerp naar mezelf</button>' +
      '</div>' +
      '<form class="wvs-mailf" novalidate hidden>' +
        '<label>Je e-mailadres<input type="email" name="e" autocomplete="email" inputmode="email" placeholder="naam@voorbeeld.nl" required></label>' +
        '<label class="wvs-optin"><input type="checkbox" name="optin" value="1"><span>Ja, mail mijn ontwerp direct en stuur me af en toe inspiratie en aanbiedingen. Afmelden kan altijd.</span></label>' +
        '<p class="wvs-note">We mailen je ontwerp met link terug naar dit adres. Lees onze <a href="/policies/privacy-policy" target="_blank" rel="noopener">privacyverklaring</a>. Liever direct zelf mailen? Open dan het ontwerp in je mailprogramma.</p>' +
        '<div class="wvs-btnrow">' +
          '<button type="submit" class="wvs-btn wvs-btn--pri">Verstuur mijn ontwerp</button>' +
          '<button type="button" class="wvs-btn" data-a="mailto">Open in mijn mailprogramma</button>' +
        '</div>' +
        '<p class="wvs-msg" role="status" aria-live="polite"></p>' +
      '</form>';
    prev.appendChild(box);

    var form = box.querySelector('.wvs-mailf'),
      msg = box.querySelector('.wvs-msg'),
      mailBtn = box.querySelector('[data-a="mail"]');

    function say(t, bad) { msg.textContent = t; msg.className = 'wvs-msg' + (bad ? ' is-bad' : ''); }

    function design() {
      var n = nCustom(), t1 = tintFor(1), t2 = tintFor(2),
        base = root.querySelector('input[name="wvc-color"]:checked'),
        leather = api.leatherSel ? api.leatherSel() : null,
        h1 = document.querySelector('h1'),
        model = h1 ? h1.textContent.trim().replace(/\s+/g, ' ') : document.title,
        lines = ['Model: ' + model];
      if (n === 2) {
        lines.push('Kleur 1 (' + api.m1 + '): ' + (t1.name || '-'));
        lines.push('Kleur 2 (' + api.m2 + '): ' + (t2.name || '-'));
      } else if (n === 1) {
        lines.push('Kleur: ' + (t1.name || '-'));
      } else {
        lines.push('Kleur: ' + (base ? base.dataset.label || '' : '-'));
      }
      if (leather) lines.push('Leder: ' + leather.name);
      if (n === 2 && state.finish && state.finish2) lines.push('Afwerking: kleur 1 ' + state.finish.toLowerCase() + ', kleur 2 ' + state.finish2.toLowerCase());
      else if (n && state.finish) lines.push('Afwerking: ' + state.finish.toLowerCase());
      var code = n || leather ? [n, t1.name, n === 2 ? t2.name : '', state.finish.toLowerCase(), leather ? leather.name : ''].join('~') : '';
      var link = location.origin + location.pathname + (code ? '?wvs=' + encodeURIComponent(code) : '');
      lines.push('Ontwerp bekijken: ' + link);
      return { text: lines.join('\n'), model: model, link: link, n: n, t1: t1, t2: t2 };
    }

    function checked() {
      var d = design();
      if (d.n && (!d.t1.name || (d.n === 2 && !d.t2.name))) { say('Vul eerst je kleur(en) in.', 1); return null; }
      if (d.n && !state.finish) { if (api.finErr()) api.finErr().hidden = false; say('Kies eerst mat of glanzend.', 1); return null; }
      return d;
    }

    function email() {
      var e = form.elements.e.value.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e)) return e;
      say('Vul een geldig e-mailadres in.', 1);
      form.elements.e.focus();
      return '';
    }

    function download() {
      var d = checked();
      if (!d || cv.hidden) return;
      var W = 1200, pad = 48, inner = W - pad * 2,
        sc = Math.min(inner / cv.width, 760 / cv.height),
        iw = cv.width * sc, ih = cv.height * sc,
        lines = d.text.split('\n').slice(0, -1),
        H = pad + ih + 40 + lines.length * 38 + 60,
        c = document.createElement('canvas');
      c.width = W; c.height = Math.round(H);
      var x = c.getContext('2d');
      x.fillStyle = state.night ? '#24211e' : '#f6f2ea'; x.fillRect(0, 0, W, c.height);
      if (state.night) { x.fillStyle = '#f6f2ea'; x.fillRect(0, pad + ih + 20, W, c.height); }
      x.drawImage(cv, (W - iw) / 2, pad, iw, ih);
      x.fillStyle = '#1b1a18'; x.font = '600 28px system-ui,Arial,sans-serif'; x.textBaseline = 'top';
      var y = pad + ih + 40;
      lines.forEach(function (l) { x.fillText(l, pad, y); y += 38; });
      x.fillStyle = '#6b665e'; x.font = '22px system-ui,Arial,sans-serif';
      x.fillText('Indicatieve weergave; we bevestigen je kleur per mail.', pad, y + 10);
      c.toBlob(function (blob) {
        if (!blob) return;
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'mijn-ontwerp-' + (handle || 'wave').slice(0, 40) + '.png';
        document.body.appendChild(a); a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
      }, 'image/png');
    }

    box.addEventListener('click', function (ev) {
      var b = ev.target.closest('button[data-a]');
      if (!b) return;
      var a = b.dataset.a;
      if (a === 'dl') download();
      else if (a === 'mail') {
        var open = form.hidden;
        form.hidden = !open;
        mailBtn.setAttribute('aria-expanded', String(open));
        if (open) form.elements.e.focus();
      } else if (a === 'mailto') {
        var d = checked(), e = d && email();
        if (!d || !e) return;
        location.href = 'mailto:' + e + '?subject=' + encodeURIComponent('Mijn ontwerp: ' + d.model) +
          '&body=' + encodeURIComponent('Mijn ontwerp\n\n' + d.text + '\n\nVoeg je gedownloade afbeelding toe als bijlage.');
        say('Je mailprogramma opent met je ontwerp. Voeg de gedownloade afbeelding toe als bijlage.');
      }
    });

    function tpl(id) {
      var t = document.getElementById(id), f = t && t.content.querySelector('form');
      return f ? f.cloneNode(true) : null;
    }
    /* A1 4 okt: formulier uit <template> heeft geen bruikbare f.action (posten ging naar de productpagina -> 404) en geen
       hCaptcha-token (Shopify: 'Missing CAPTCHA token'). Nu: formulier verborgen in de pagina, Shopify.captcha.protect bindt
       hCaptcha, daarna posten met token. Resultaat: true (verstuurd), {challenge: url} (Shopify vraagt extra controle) of false. */
    function post(f) {
      return new Promise(function (res) {
        var holder = document.createElement('div'), done = false,
          cap = window.Shopify && Shopify.captcha && Shopify.captcha.protect;
        holder.hidden = true; holder.appendChild(f); document.body.appendChild(holder);
        function finish(v) { if (done) return; done = true; setTimeout(function () { holder.remove(); }, 1000); res(v); }
        f.submit = function () {
          var fd = new FormData(f);
          if (cap && !fd.get('h-captcha-response')) return;
          fetch((f.getAttribute('action') || '/contact').split('#')[0], { method: 'POST', body: fd, credentials: 'same-origin' })
            .then(function (r) { finish(/\/challenge/.test(r.url) ? { challenge: r.url } : r.ok); })
            .catch(function () { finish(false); });
        };
        function go() { try { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } catch (x) { finish(false); } }
        if (cap) cap(f, go); else go();
        setTimeout(function () { finish(false); }, 25000);
      });
    }
    function modelTag() {
      var m = (handle || '').match(/(?:^|[^0-9])(\d{4})/);
      return /sphere/.test(handle || '') ? 'ontwerp-2176' : m ? 'ontwerp-' + m[1] : 'ontwerp-wave';
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var d = checked(), e = d && email();
      if (!d || !e) return;
      var optin = form.elements.optin.checked,
        btn = form.querySelector('button[type=submit]'),
        contact = tpl('wvs-mail-tpl'),
        customer = optin ? tpl('wvs-cust-tpl') : null;
      function fail() { say('Versturen lukt nu niet. Gebruik "Open in mijn mailprogramma" of mail ons het ontwerp.', 1); btn.disabled = false; }
      if (!contact) return fail();
      contact.elements['contact[email]'].value = e;
      contact.elements['contact[body]'].value =
        'Kleurontwerp via de website. ' +
        (optin ? 'Klant gaf marketingtoestemming; Shopify Flow mailt het ontwerp automatisch (alleen bij een nieuwe klant). Is dit adres al klant? Mail het ontwerp dan handmatig.' : 'Geen marketingtoestemming: graag het ontwerp handmatig terugmailen.') +
        ' Adres: ' + e + '.\n\n' + d.text;
      btn.disabled = true;
      say('Even geduld...');
      var steps = [];
      if (customer) {
        customer.elements['contact[email]'].value = e;
        customer.elements['contact[tags]'].value = 'ontwerp-mail, configurator, ' + modelTag();
        customer.elements['contact[note]'].value = d.text;
        steps.push(post(customer));
      }
      steps.push(post(contact));
      Promise.all(steps).then(function (res) {
        var ch = res.filter(function (x) { return x && x.challenge; })[0];
        if (res.some(function (x) { return x === true; })) {
          say(optin ? 'Gelukt. Je ontwerp is onderweg naar ' + e + '.' : 'Gelukt. We mailen je ontwerp terug naar ' + e + '.');
          btn.disabled = false;
          try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('ontwerp_gemaild', { optin: optin, model: d.model }); } catch (x) {}
        } else if (ch) {
          say('Bijna klaar: Shopify vraagt even te bevestigen dat je geen robot bent. ');
          var go = document.createElement('button');
          go.type = 'button'; go.className = 'wvs-btn wvs-btn--pri'; go.textContent = 'Bevestigen en versturen';
          /* window.open (zonder noopener) neemt de opgeslagen formuliergegevens (sessionStorage) mee naar het nieuwe tabblad */
          go.addEventListener('click', function () { window.open(ch.challenge, '_blank'); say('Rond de controle af in het nieuwe tabblad; daarna is je ontwerp verstuurd.'); });
          msg.appendChild(go);
          btn.disabled = false;
        } else fail();
      });
    });

    var q = (location.search.match(/[?&]wvs=([^&]+)/) || [])[1];
    if (q) try {
      var parts = decodeURIComponent(q).split('~'), cnt = parts[0], lname = parts[4] || '',
        lIn = lname ? [].slice.call(root.querySelectorAll('input[name="wvc-leder"]')).filter(function (x) { return x.dataset.label === lname; })[0] : null,
        cIn = [].slice.call(root.querySelectorAll('input[name="wvc-color"]')).filter(function (x) { return new RegExp('^' + cnt + '\\s+kleur', 'i').test(x.dataset.label || ''); })[0];
      if (lIn) lIn.click();
      if (cIn) {
        cIn.click();
        setTimeout(function () {
          if (in1) { in1.value = parts[1] || ''; in1.dispatchEvent(new Event('input', { bubbles: true })); }
          if (in2 && cnt === '2') { in2.value = parts[2] || ''; in2.dispatchEvent(new Event('input', { bubbles: true })); }
          var fin = [].slice.call(root.querySelectorAll('input[name="wvs-finish"]')).filter(function (x) { return (x.dataset.f || '').toLowerCase() === parts[3]; })[0];
          if (fin) { fin.checked = true; state.finish = fin.dataset.f; }
          soon();
        }, 400);
      }
    } catch (x) {}
  }

  document.addEventListener('wvs:init', init);
  init();
})();